/**
 * Helpers for the place (pharmacy / laboratory / imaging center) a
 * prescription was referred to.
 *
 * They live outside the component so the mapping of the raw type of the place
 * can be unit tested without rendering the whole modal.
 */

// The backend sends the raw type of the place: phar | img | lab.
export const PLACE_TYPE_LABEL_KEY = Object.freeze({
  phar: "Pharmacy",
  img: "Diagnostic Imaging",
  lab: "Laboratory",
});

/**
 * Translates the raw type of a place to its label.
 *
 * @param {string|null|undefined} type one of phar | img | lab
 * @param {Function} t the i18n translate function
 * @returns {string|null} the label, null when the type is missing or unknown
 */
export const getPlaceTypeLabel = (type, t) => {
  if (!Object.prototype.hasOwnProperty.call(PLACE_TYPE_LABEL_KEY, type)) {
    return null;
  }

  return t(PLACE_TYPE_LABEL_KEY[type]);
};
